export function showFallbackImage(fallbackUrl: string) {
	return (e: Event) => {
		if (fallbackUrl) {
			(e.currentTarget as HTMLImageElement).src = fallbackUrl;
		}
	};
}
